import React from 'react'

const EtAdminPixelStatus = () => {
  return (
    <div>EtAdminPixelStatus</div>
  )
}

export default EtAdminPixelStatus
